<template>
    <div class="v-uploader-normal">
        <input
            v-show="false"
            ref="core"
            :multiple="multiple"
            class="v-uploader__core"
            type="file"
            @change="handleFileChange"
        />
        <template v-if="!draggable">
            <slot>
                <v-button :disabled="disabled" class="v-uploader__defaultFace" kind="primary">选择文件</v-button>
            </slot>
        </template>
        <template v-else>
            <v-uploader-dnd-area :disabled="disabled" @change="handleDragChange">
                <slot>
                    <p>把文件拖到这里，或者点击选择文件</p>
                </slot>
            </v-uploader-dnd-area>
        </template>
    </div>
</template>

<script>
import Axios from 'axios';
import VUploaderDndArea from './uploader-dnd-area.vue';
import Constants from './constants';

const axios = Axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
});

export default {
    components: {
        VUploaderDndArea
    },
    // name: 'VUploader',
    props: {
        kind: {
            type: String,
            default: 'normal'
        },
        url: {
            type: String,
            required: true
        },
        sizeLimit: {
            type: String,
            default: '2MB'
        },
        sizeNumKb: {
            type: Number,
            default: 2048
        },
        typeLimit: {
            type: String,
            default: '*.jpg;*.gif;*.jpeg;*.png;*.bmp'
        },
        typeReg: {
            type: RegExp,
            default: () => new RegExp()
        },
        multiple: Boolean,
        withCredentials: Boolean,
        // fileList: Array,
        disabled: Boolean,
        draggable: Boolean
    },

    methods: {
        handleDragChange(files) {
            this.$emit('file', files);
        },
        handleFileChange(evt) {
            // IE11 bug, clear file will trigger this event again.
            if (!evt.target.files || !evt.target.files.length) {
                return;
            }

            this.$emit('file', evt.target.files);
            evt.target.value = null;
        },

        postFile(file) {
            this._sendFiles(file);
        },

        checkFileType(file) {
            // it can't get file type for some file for example: csv. so use the filename inestad to do the check.
            const type = file.name.substring(file.name.lastIndexOf('.') + 1);
            const flag = this.typeReg.test(type);

            if (!flag) {
                file.error = {
                    type: 'TYPE',
                    message: 'File type invalid'
                };
            }

            return flag;
        },
        checkFileSize(file) {
            const size = file.size / 1024;
            const flag = this.sizeNumKb === 0 || size <= this.sizeNumKb;

            if (!flag) {
                file.error = {
                    type: 'SIZE',
                    message: 'File size exceed'
                };
            }

            return flag;
        },
        _sendFiles(file) {
            const that = this;
            const formdata = new FormData();
            const { CancelToken } = Axios;

            formdata.append('lbf-file-upload', file.raw, file.name);
            formdata.append('file_size_limit', this.sizeLimit);
            formdata.append('file_types', this.typeLimit);
            // eslint-disable-next-line
            for (const key in this.data) {
                formdata.append(key, this.data[key]);
            }

            axios.post(this.url, formdata, {
                url: this.url,
                withCredentials: this.withCredentials,
                onUploadProgress(evt) {
                    if (evt.lengthComputable) {
                        const percentComplete = evt.loaded / evt.total;
                        file.percentage = Math.floor(percentComplete * 100);
                        that.$emit('progress', {
                            file,
                            origin: evt
                        });
                    }
                },
                cancelToken: new CancelToken(c => {
                    file.cancelFunc = () => {
                        c();
                        file.status = Constants.STATUS.CANCELLED;
                    };
                })
            })
                .then(res => {
                    this.$emit('success', {
                        file,
                        origin: res
                    });
                })
                .catch(err => {
                    if (file.status !== Constants.STATUS.CANCELLED) {
                        this.$emit('error', {
                            file,
                            type: 'SERVER',
                            origin: err
                        });
                    }
                });
        }
    }
};
</script>
